module.exports = __webpack_public_path__ + "img/testpaper_audio_play.e02a568c.svg";